import {
  CourseCharacteristic,
  CourseCommission,
  CourseStatus,
  CourseVenue,
  TeacherAssignmentStatus,
} from '../types/trainingCourse'

export const teacherAssignmentStatuses: TeacherAssignmentStatus[] = [
  'Da inviare',
  'Inviato',
  'Confermato',
]

// Seed lists for the self-feeding selects
export const equipmentTypeSeed = [
  'Videoproiettore',
  'Manichino RCP',
  'Estintori da addestramento',
  'Carrello elevatore',
  'Piattaforma aerea PLE',
]

export const supplierSeed = [
  'Croce Verde Formazione',
  'Forklift Academy Srl',
  'Alimenta Learning',
]

export const courseTabs: { id: CourseStatus; label: string }[] = [
  { id: 'attivi', label: 'Corsi attivi' },
  { id: 'programma', label: 'Corsi in programma' },
  { id: 'archivio', label: 'Archivio corsi' },
  { id: 'ondemand', label: 'Corsi on-demand' },
]

export const courseStatusLabels: Record<CourseStatus, string> = {
  attivi: 'Attivo',
  programma: 'In programma',
  archivio: 'Archiviato',
  ondemand: 'On-demand',
}

export const courseCharacteristics: CourseCharacteristic[] = [
  'Unico',
  'Trainante',
  'Trainato',
]

export const courseCommissions: { value: CourseCommission; label: string }[] =
  [
    { value: 'SEFORM', label: 'Commessa SEFORM' },
    { value: 'Cliente', label: 'Commessa cliente' },
  ]

export const courseVenues: { value: CourseVenue; label: string }[] = [
  { value: 'seform', label: 'In presenza presso sede SEFORM' },
  { value: 'cliente', label: 'In presenza presso sede cliente' },
  { value: 'fad', label: 'In presenza in FAD' },
  { value: 'blended', label: 'Blended' },
]
